import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalTitle,
} from '@cambridgeassessment/cambridge-ui';
import { Box, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import useOrgUserDetails from 'src/hooks/useOrgUserDetails';
import { useStyles } from './styles';
import { getFullName } from './utils';

const ResetUserPassword: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);

  const { resetUserPassword, userDetails } = useOrgUserDetails();
  const name = getFullName(userDetails.firstName, userDetails.lastName);

  const openModal = () => setOpen(true);
  const closeModal = () => setOpen(false);

  const classes = useStyles();

  return (
    <>
      <Button
        variant="outlined"
        style={{ color: '#00588f' }}
        onClick={openModal}
        data-testid="open-confirmation-modal"
      >
        Reset password
      </Button>

      <Modal
        open={open}
        size="small"
        onClose={closeModal}
        data-testid="confirmation-modal"
      >
        <Box className={classes.modalTitle}>
          <ModalTitle onClose={closeModal} data-testid="confirmation-header">
            {`Reset password for ${name}?`}
          </ModalTitle>
        </Box>
        <ModalContent>
          <Typography
            variant="body1"
            className={classes.modalText}
            data-testid="confirmation-body"
          >
            Are you sure that you want to reset the password for{' '}
            {name === 'user' ? name : <strong>{name}</strong>}
            ?
            <br />
            <br />
            They will be sent a reset password email, and their old password
            will no longer work.
          </Typography>
        </ModalContent>
        <ModalActions>
          <Button
            onClick={closeModal}
            color="primary"
            variant="text"
            data-testid="cancel-confirmation-modal"
          >
            Cancel
          </Button>
          <Button
            onClick={resetUserPassword}
            color="primary"
            data-testid="confirm-confirmation-modal"
          >
            Reset password
          </Button>
        </ModalActions>
      </Modal>
    </>
  );
};
export default ResetUserPassword;
